var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API_PATHS } from '../../../types/apiPaths';
import { getTodayCs } from '../formTypes';
var handlers = {};
/** Register a named action handler. Idempotent — re-registering replaces. */
export var registerActionHandler = function (name, handler) {
    handlers[name] = handler;
};
/** Look up a registered handler by name; returns undefined when unknown. */
export var getActionHandler = function (name) { return handlers[name]; };
/**
 * `fetchUrlMetadata` (TASK-044, format adjusted in TASK-124) — reads the URL
 * stored in this subfield's sibling `${pathPrefix}.u` (its first value) and writes a
 * citation string of the form `"www(Page title), cit. D. M. YYYY"` into
 * `${pathPrefix}.a.value`. The format matches the dominant Aleph cs cataloging
 * convention used by NKP (98.72% of 1.23M historical `cit.` rows per
 * 2026-05-14 audit) — no leading zeros, no trailing colon.
 *
 * Errors surface as user-facing toasts; the form value is left untouched on
 * any failure.
 */
var fetchUrlMetadata = function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
    var getAny, setAny, u, url, response, err_1, status_1, title, citation;
    var _c, _d, _e, _f, _g;
    var pathPrefix = _b.pathPrefix, getValues = _b.getValues, setValue = _b.setValue, okapiKy = _b.okapiKy, showToast = _b.showToast;
    return __generator(this, function (_h) {
        switch (_h.label) {
            case 0:
                getAny = getValues;
                setAny = setValue;
                u = getAny("".concat(pathPrefix, ".u"));
                url = ((_d = (_c = u === null || u === void 0 ? void 0 : u.values) === null || _c === void 0 ? void 0 : _c.map(function (entry) { var _a; return ((_a = entry.value) !== null && _a !== void 0 ? _a : '').trim(); }).find(Boolean)) !== null && _d !== void 0 ? _d : ((_e = u === null || u === void 0 ? void 0 : u.value) !== null && _e !== void 0 ? _e : '')).trim();
                if (!url) {
                    showToast('warning', 'ui-czna-authorities.marc.670.fetchTitle.error.emptyUrl');
                    return [2 /*return*/];
                }
                _h.label = 1;
            case 1:
                _h.trys.push([1, 3, , 4]);
                return [4 /*yield*/, okapiKy
                        .get(API_PATHS.CZNA_AUTHORITIES_URL_METADATA, { searchParams: { url: url } })
                        .json()];
            case 2:
                response = _h.sent();
                return [3 /*break*/, 4];
            case 3:
                err_1 = _h.sent();
                status_1 = (_f = err_1 === null || err_1 === void 0 ? void 0 : err_1.response) === null || _f === void 0 ? void 0 : _f.status;
                if (typeof status_1 === 'number') {
                    showToast('error', 'ui-czna-authorities.marc.670.fetchTitle.error.fetchFailed');
                }
                else {
                    showToast('error', 'ui-czna-authorities.marc.670.fetchTitle.error.networkError');
                }
                return [2 /*return*/];
            case 4:
                title = (_g = response.title) === null || _g === void 0 ? void 0 : _g.trim();
                if (!title) {
                    showToast('warning', 'ui-czna-authorities.marc.670.fetchTitle.error.noTitle');
                    return [2 /*return*/];
                }
                citation = "www(".concat(title, "), cit. ").concat(getTodayCs());
                setAny("".concat(pathPrefix, ".a.value"), citation, { shouldDirty: true, shouldValidate: true });
                return [2 /*return*/];
        }
    });
}); };
registerActionHandler('fetchUrlMetadata', fetchUrlMetadata);
